<dialog shEscapeDialog (shEscapePressed)="closeModal()" #shDialog class="sh-dialog-container">
    <div [ngClass]="style">
        <header *ngIf="title" class="sh-dialog__header">
            <h3 class="sh-dialog__header__title">{{ title }}</h3>
        </header>
        <section class="sh-dialog__content">
            <ng-content></ng-content>
        </section>
        <footer class="sh-dialog__footer" *ngIf="actions">
            <div class="sh-action-group -sh-align-end">
                <sh-action-item *ngFor="let actionItem of actions" [item]="actionItem" class="sh-action-group__item"></sh-action-item>
            </div>
        </footer>
        <button type="button" (click)="closeModal()" class="sh-pure-icon-button sh-dialog__close" aria-label="close">
            <svg sh-icon [name]="'close'" class="sh-icon-button__icon" aria-hidden="true"></svg>
        </button>
    </div>
</dialog>
